import React, {Component} from 'react';
import {Col,  FormGroup, Input, Label, Row, Tooltip} from "reactstrap";

class PasswordInputComponent extends Component{
    constructor(props){
        super(props);
        this.state={
            newPasswordClass: "",
            repeatedPasswordClass: "",
            repeatedPasswordTooltipOpen: false,
            passwordTooltipOpen: false,
            repeatedPasswordTooltipText: "",
            passwordTooltipText: "",
            isValid : false,
        };
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.closeRepeatedPasswordTooltip = this.closeRepeatedPasswordTooltip.bind(this);
        this.openRepeatedPasswordTooltip = this.openRepeatedPasswordTooltip.bind(this);
        this.closePasswordTooltip = this.closePasswordTooltip.bind(this);
        this.openPasswordTooltip = this.openPasswordTooltip.bind(this);
    };
    openPasswordTooltip() {
        this.setState({
            newPasswordClass: 'border-danger',
            passwordTooltipOpen: true,
            passwordTooltipText: "Šifra mora imati više od 6 karaktera",
        })
    }
    closePasswordTooltip() {
        this.setState({
            newPasswordClass: 'border-success',
            passwordTooltipOpen: false,
            passwordTooltipText: "",
        })
    }

    openRepeatedPasswordTooltip() {
        this.setState({
            repeatedPasswordClass: 'border-danger',
            repeatedPasswordTooltipOpen: true,
            repeatedPasswordTooltipText: "Šifre se moraju poklapati!",
        });
    }
    closeRepeatedPasswordTooltip() {
        this.setState({
            repeatedPasswordClass: 'border-success',
            repeatedPasswordTooltipOpen: false,
            repeatedPasswordTooltipText: "",
        });
    }
    static isPasswordStrong(password) {
        //much security, many strong, such safe, wow
        //TODO dodati jos par uslova, poput krila od komarca i krv vestice iz Ugande
        return (password.length > 6);
    }
    onPasswordChange(_e){
        if(this.state.isValid){
            this.props.onInvalidPassword();
            this.setState({
                isValid: false,
            });
        }
        const strongPass = PasswordInputComponent.isPasswordStrong(this.newPassword.value);
        const samePasswords = this.newPassword.value === this.repeatedPassword.value;
        if(strongPass && samePasswords) {
            this.props.onValidPassword(this.newPassword.value);
            this.setState({
                isValid: true,
            });
        }
        //below is only tooltip and border color handling
        !strongPass ? this.openPasswordTooltip() : this.closePasswordTooltip();
        (!samePasswords || !strongPass) ? this.openRepeatedPasswordTooltip() : this.closeRepeatedPasswordTooltip();
    }

    render(props){
        if(!this.props.onValidPassword || !this.props.onInvalidPassword){
            return <div></div>
        }
        else{
            return(
                <Row>
                    <Col>
                        <FormGroup>
                            <Label htmlFor="newPassword"> Šifra </Label>
                            <Input type="password" id="newPassword" name="newPassword"
                                   innerRef={(input) => { this.newPassword = input }}
                                   className={this.state.newPasswordClass}
                                   onChange={this.onPasswordChange}
                                   onBlur={this.onPasswordChange}
                                   autoComplete='new-password'/>
                            <Tooltip
                                target="newPassword"
                                isOpen={this.state.passwordTooltipOpen}>
                                {this.state.passwordTooltipText}
                            </Tooltip>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label htmlFor="repeatedPassword"> Ponovite šifru </Label>
                            <Input type="password" id="repeatedPassword" name="repeatedPassword"
                                   innerRef={(input) => { this.repeatedPassword = input }}
                                   className={this.state.repeatedPasswordClass}
                                   onChange={this.onPasswordChange}
                                   onBlur={this.onPasswordChange}
                                   autoComplete='new-password'/>
                            <Tooltip
                                target="repeatedPassword"
                                isOpen={this.state.repeatedPasswordTooltipOpen}>
                                {this.state.repeatedPasswordTooltipText}
                            </Tooltip>
                        </FormGroup>
                    </Col>
                </Row>
            );
        }
    }
}
export default PasswordInputComponent;